document.querySelectorAll('.bm-photo-reviews').forEach((section) => {
  const grid = section.querySelector('.bm-photo-review-grid');
  const cards = Array.from(grid.querySelectorAll('[data-review-card]'));
  const moreButton = section.querySelector('.bm-photo-reviews-more button');
  let expanded = false;
  let columnCount = 0;

  const getColumnCount = () => window.matchMedia('(max-width: 680px)').matches
    ? 2
    : window.matchMedia('(max-width: 900px)').matches ? 3 : 4;

  const updateVisibleCards = () => {
    columnCount = getColumnCount();
    const columns = Array.from({ length: columnCount }, () => {
      const column = document.createElement('div');
      column.className = 'bm-photo-review-column';
      return column;
    });
    grid.replaceChildren(...columns);

    cards.forEach((card, index) => {
      card.hidden = !expanded && index >= 10;
      if (card.hidden) return;
      const target = index < columnCount
        ? columns[index]
        : columns.reduce((shortest, column) => column.offsetHeight < shortest.offsetHeight ? column : shortest);
      target.append(card);
    });

    moreButton.parentElement.hidden = cards.length <= 10;
    moreButton.setAttribute('aria-expanded', String(expanded));
    moreButton.querySelector('span').textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
  };

  moreButton.addEventListener('click', () => {
    expanded = !expanded;
    updateVisibleCards();
  });
  window.addEventListener('resize', () => {
    if (getColumnCount() !== columnCount) updateVisibleCards();
  });

  updateVisibleCards();
});
